<template>
  <div class="animated-loader">
    <div class="first-row">
      <lottie-player class="pyramid"
                     :src="JSON.stringify(require('../assets/animations/loader-pyramid.json'))"
                     :preserveAspectRatio="'xMidYMax'"
                     autoplay
                     loop/>
      <lottie-player class="arrows"
                     :src="JSON.stringify(require('../assets/animations/loader-arrows.json'))"
                     :preserveAspectRatio="'xMidYMax'"
                     autoplay
                     loop/>
    </div>
    <lottie-player
        class="second-row"
        :src="JSON.stringify(require('../assets/animations/loader-wavy-line.json'))"
        :preserveAspectRatio="'none'"
        autoplay
        loop/>
    <div class="sky">
      <lottie-player class="sun"
                     :src="JSON.stringify(require('../assets/animations/loader-sun.json'))"
                     :preserveAspectRatio="'xMinYMax'"
                     autoplay
                     loop/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnimatedLoader',
};
</script>

<style scoped lang="scss">
@import "../scss/riseup-colors";

.animated-loader {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .first-row {
    height: 102px;
    width: 100%;
    display: flex;

    .pyramid {
      width: 102px;
      background-color: $riseup_blue;
    }

    .arrows {
      background-color: $riseup_light_green;
    }
  }

  .second-row {
    height: 100px;
    background-color: $riseup_light_red;
  }

  .sky {
    height: 100%;
    display: flex;
    .sun {
      background-color: $riseup_dark_yellow;
    }
  }
}

</style>
